import { ProductApiDto } from '@b2x/storefront-api-js-client/src/dto';

import { RecommendedCartProductsA } from './RecommendedCartProductsA';
import { PropsWithCustomComponent, VariantsController } from './VariantsController';

export interface RecommendedCartProductsProps {
  classNames?: string;
  products: Array<ProductApiDto>;
}

export type RecommendedCartProductsVariants = 'A';

const RecommendedCartProductsController = (props: PropsWithCustomComponent<RecommendedCartProductsProps>) => (
  <VariantsController<RecommendedCartProductsProps, RecommendedCartProductsVariants>
    {...props}
    variantsControllerConfig={{
      componentVariants: { A: RecommendedCartProductsA },
      name: 'RecommendedCartProducts',
    }}
  />
);
export { RecommendedCartProductsController as RecommendedCartProducts };
